// @flow

import _ from 'lodash/fp';
import React from 'react';
import Linkify from 'react-linkify';
import './CustomerCustomProductList.css';
import CustomerProductImage from '../CustomerProductImage/CustomerProductImage';
import FormattedPrice from '../FormattedPrice/FormattedPrice';

export type Props = {
  customProducts: any[],
};

const CustomerCustomProductList = ({customProducts}: Props) => {
  return (
    <div className="CustomerCustomProductList">
      {_.map(product => (
        <div
          key={product.id}
          className="product">
          <div className="product-container">
            <div className="column medium-3 relative product-image">
              <CustomerProductImage file={product.image}/>
            </div>
            <div className="column">
              <div className="name">
                {product.name}
              </div>
              <div className="section quantity">
                Antal: {product.quantity}
              </div>
              <div className="section price">
                <span>Totalpris: <FormattedPrice value={product.totalSellingPrice} /></span>
              </div>
              {!_.isEmpty(product.externalDescription) &&
                <div className="section description">
                  <Linkify
                    properties={{target: '_blank'}}>
                    <p className="preserve-whitespace">{product.externalDescription}</p>
                  </Linkify>
                </div>
              }
            </div>
          </div>
        </div>
      ), customProducts)}
    </div>
  );
};

export default CustomerCustomProductList;



// WEBPACK FOOTER //
// ./src/components/CustomerCustomProductList/CustomerCustomProductList.js